/* quickadd-max-fix.js */
(function () {
  function parseProductJSON(scope) {
    if (!scope) return null;
    const s = scope.querySelector(
      'script[type="application/json"][data-product-json], script[type="application/json"][data-product]'
    ) || document.querySelector(
      'script[type="application/json"][data-product-json], script[type="application/json"][data-product]'
    );
    if (!s) return null;
    try { return JSON.parse(s.textContent.trim()); } catch (e) { return null; }
  }

  function getVariantFromForm(form, product) {
    const idEl = form.querySelector('input[name="id"], select[name="id"]');
    const vid = idEl ? String(idEl.value) : null;
    if (!vid || !product || !product.variants) return null;
    return product.variants.find(v => String(v.id) === vid);
  }

  function applyRules(form) {
    const input = form.querySelector('input[name="quantity"]');
    if (!input) return;

    const product = parseProductJSON(form) || parseProductJSON(form.closest('product-form')) || parseProductJSON(document);
    const v = getVariantFromForm(form, product);
    if (!v) return;

    const min  = v.quantity_rule && v.quantity_rule.min ? Number(v.quantity_rule.min) : 1;
    const step = v.quantity_rule && v.quantity_rule.increment ? Number(v.quantity_rule.increment) : 1;

    const ruleMax = v.quantity_rule && Number(v.quantity_rule.max) > 0 ? Number(v.quantity_rule.max) : 0;
    const invMax  = (v.inventory_management && v.inventory_policy !== 'continue') ? Number(v.inventory_quantity) : 0;
    const max     = ruleMax || invMax || null; // prioridad a quantity_rule.max; si no, inventario; si no, sin tope

    input.min  = String(min);
    input.step = String(step);
    if (max) input.max = String(max); else input.removeAttribute('max');

    const current = Number(input.value || min);
    if (max && current > max) input.value = String(max);
    if (current < min) input.value = String(min);
  }

  function attach(form) {
    if (!form || form.__qtyFixAttached) return;
    form.__qtyFixAttached = true;

    applyRules(form);

    // Reaplicar cuando cambia la variante o se toca la cantidad
    form.addEventListener('change', function (e) {
      const t = e.target;
      if (!t) return;
      const name = t.name || '';
      if (name === 'id' || name.startsWith('options[')) {
        applyRules(form);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-form form').forEach(attach);

    // Detectar formularios que aparecen al abrir el Quick Add (modal/drawer)
    const mo = new MutationObserver((muts) => {
      muts.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('product-form form')) attach(node);
          node.querySelectorAll && node.querySelectorAll('product-form form').forEach(attach);
        });
      });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  });
})();